import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Table,
  Spin,
  Select,
  Divider,
  Col,
  Form,
  DatePicker,
  Modal,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";

// PROJECT IMPORTS
import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import { rightAction } from "../../../../redux/actions";
import DownloadTableButtons from "../../../../components/layouts/enhancement/DownloadTableButtons";
import { apiConfig, labelConfig, staticConfig } from "../../operations.config";
import dayjs from "dayjs";
import Notiflix from "notiflix";
import styles from "../../../../assets/styles/styles";
import { handleFlgStatus } from "../../../../components/facilities/AccountFacility";

const { Text } = Typography;

const columns = [
  {
    title: labelConfig.dealReference,
    dataIndex: "dealReference",
    // sorter: (a, b) => a.dealReference.localeCompare(b.dealReference),
  },
  {
    title: labelConfig.counterParty,
    dataIndex: "counterParty",
  },
  {
    title: labelConfig.proposeRate,
    dataIndex: "proposeRate",
  },
  {
    title: labelConfig.dealTenor,
    dataIndex: "dealTenor",
  },

  {
    title: labelConfig.dealAmount,
    dataIndex: "dealAmount",
  },
  {
    title: labelConfig.status,
    dataIndex: "status",
  },
];

const ManageBond = (props) => {
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const { Text } = Typography;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  const [tableStatus, setTableStatus] = useState("Status");
  const [bondListData, setBondListData] = useState([]);
  const [loanList, setLoanList] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [currentDate, setCurrentDate] = useState("");
  const childref = useRef();

  //DECLARED METHODS
  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;

    if (!searchKey) {
      setBondListData(originalList);
      return;
    }

    const filterBySearch = originalList.filter(
      (item) =>
        item?.name?.toLowerCase().includes(searchKey) ||
        item?.branch?.toLowerCase().includes(searchKey),
    );

    setBondListData(filterBySearch);
  }

  function selectTableCount(value) {
    setTableCount(value);
  }

  //END METHODS DECLARED

  useEffect(() => {
    getBondTableList();
    defaultDate();
  }, []);

  const defaultDate = () => {
    setCurrentDate(dayjs());
  };

  const getBondTableList = () => {
    setIsLoading(true);

    let body = {
      session,
    };

    const url = `${apiConfig.Bond}`;

    setIsLoading(false);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;
        let tempBondListArray = [];

        objList.forEach((element) => {
          tempBondListArray.push({
            key: element?.id,
            id: element.id,
            dealReference: element?.id ? element?.id : "-",
            counterParty: element?.name ? element?.name : "-",
            proposeRate: `${element?.annualInterestRate ? element?.annualInterestRate : "-"}%`,
            dealTenor: element?.graceOnArrearsAgeing
              ? `${element?.graceOnArrearsAgeing} Days`
              : "-",
            dealAmount: element?.maxPrincipal ? element?.maxPrincipal : "-",
            status: handleFlgStatus(
              element?.status === "loanProduct.active"
                ? "Active"
                : "loanProduct.inActive"
                  ? "Inactive"
                  : "-",
              {},
              true,
              element,
            ),
          });
        });

        setBondListData(tempBondListArray);
        setOriginalList(tempBondListArray);
      }
    });
  };

  const onSelectItemAction = (selectedKeys, selectedRows) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRowKeys(selectedKeys);
    setSelectedRow(selectedRows);

    if (selectedKeys.length === 1 || selectedKeys.length > 1) {
      BOM.HasPermission("ACTIVATE_CLIENT_CHECKER") &&
        [cnt.RIGHT_APPROVE_BTN].map((item) => {
          dispatch({ type: item });
        });
    } else {
      dispatch({ type: cnt.CLEAR_RIGHT_BTN });
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectItemAction,
    // selections: [Table.SELECTION_ALL, Table.SELECTION_NONE],
  };

  function handleApprove() {
    childref?.current?.showModal();
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/new-customer", { state: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onApprove={handleApprove}
      onAdd={handleOnCreate}
      pageItems={staticConfig.moneyMarketBondBreadcrumbItems}
    >
      <TopContent
        pageTitle={labelConfig.moneyMarketBond}
        createPageTitle={labelConfig.createMoneyMarketBond}
      />
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
          marginTop: 20,
        }}
      >
        {/*RENDER TABLE LIST HERE*/}

        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ margin: "0px 5px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by deal deference ID..."
                style={{
                  width: 300,
                }}
                prefix={<SearchOutlined />}
              />
            </div>
            <div style={{ marginBottom: "auto", marginLeft: 10 }}>
              <Select
                defaultValue={tableStatus}
                options={[
                  { value: "5", label: "Active" },
                  { value: "10", label: "Inactive" },
                ]}
              />
            </div>
            {/* <DownloadTableButtons
                            downloadData={bondListData}
                            columns={columns}
                            fileName={"Bond List"}
                        /> */}
          </Row>

          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={bondListData}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};
const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(ManageBond);
